import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * Layout wrapper element, used to wrap content (sometimes needed to place multiple items in a certain slot)
 *
 * @slot - Unnamed slot (default)
 *
 * @prop {Number} verticalpadding - optional, used to set the top and bottom padding of the wrapper (default 0)
 *
 */
let SDBLayoutWrapper = class SDBLayoutWrapper extends LitElement {
    constructor() {
        super(...arguments);
        this.verticalpadding = 0;
    }
    render() {
        return html ` <slot></slot> `;
    }
    firstUpdated() {
        this.style.setProperty('--verticalpadding', this.verticalpadding + 'px');
    }
};
SDBLayoutWrapper.styles = [
    elements,
    css `
            :host {
                display: grid;
                grid-template-columns: 1fr;
                grid-auto-rows: fit-content;
                place-items: start stretch;
                grid-auto-flow: row;
                row-gap: var(--verticalpadding);
            }
        `,
];
__decorate([
    property({ type: Number })
], SDBLayoutWrapper.prototype, "verticalpadding", void 0);
SDBLayoutWrapper = __decorate([
    customElement('sdb-layout-wrapper')
], SDBLayoutWrapper);
export { SDBLayoutWrapper };
//# sourceMappingURL=sdb-layout-wrapper.js.map